import { CustomerDTO } from '../../common/types.js'
import { ProductProps } from '../components/product/product.js'
import { SubscriptionLisaAndProduct } from './subscription-lisa-and-product.js'
import { Subscription } from './subscription.js'

export class Customer {
    readonly data: CustomerDTO
    readonly activeSubscriptions: ProductProps[] = []

    constructor(customer: CustomerDTO, products?: SubscriptionLisaAndProduct[]) {
        this.data = customer

        if (this.data.activeSubscriptions) {
            this.activeSubscriptions = this.data.activeSubscriptions.map((subscriptionDTO) => {
                const subscription = new Subscription(subscriptionDTO, products)
                subscription.customer = this

                return subscription.mainProduct.getProductCard(
                    subscription.uuid,
                    subscriptionDTO,
                    subscriptionDTO.contractStartDatetime,
                )
            })
        }
    }

    get uuid() {
        return this.data.uuid
    }

    get localeCode() {
        return this.data.localeCode
    }

    get hasEsisOffers() {
        return this.data.hasOffers
    }

    get status() {
        return this.data.status
    }

    get visualLocaleCode() {
        return this.data.visualLocaleCode
    }

    get fullName() {
        return this.data.fullName
    }

    get marketingTerms() {
        return this.data.marketingTerms
    }

    get firstName() {
        return this.data.firstName
    }

    get lastName() {
        return this.data.lastName
    }

    get email() {
        return this.data.email
    }

    get phone() {
        return this.data.phone
    }

    get personalNumber() {
        return this.data.personalNumber
    }

    get postalCode() {
        return this.data.postalCode
    }

    get city() {
        return this.data.city
    }

    get address() {
        return this.data.address
    }

    get canEditPostalCode() {
        return !this.postalCode || this.postalCode.length > 40
    }

    get canEditAddress() {
        return !this.address || this.address.length > 40
    }

    get canEditCity() {
        return !this.city || this.city.length > 40
    }
}
